import '../../../sass/screens/sign_up/index.scss';
import './privacy_policy';

import { initializeForm } from '../../utils/form';
import { initializeRecaptcha } from '../../utils/recaptcha';

import {
  validateEmail,
  validatePassword,
  validatePasswordComplexity,
  validateNotEmpty,
} from '../../utils/validators';

$(document).ready(() => {
  $('#personal-account-btn')
    .mouseover(() => {
      $('#personal-account-hint').removeClass('d-none');
      $('#business-account-hint').addClass('d-none');
    })
    .mouseout(() => {
      $('#personal-account-hint').addClass('d-none');
    });

  $('#business-account-btn')
    .mouseover(() => {
      $('#business-account-hint').removeClass('d-none');
      $('#personal-account-hint').addClass('d-none');
    })
    .mouseout(() => {
      $('#business-account-hint').addClass('d-none');
    });

  $('.nav-button').click(function () {
    $(this).removeClass('active');
  });

  const personalSignUpFormSelector = $('#personal-sign-up-form');
  const businessSignUpFormSelector = $('#business-sign-up-form');

  initializeRecaptcha();

  initializeForm(personalSignUpFormSelector, {
    preventDefault: false,
    validate: (values) => {
      const errors = {
        ...validateEmail(values),
        ...validatePassword(values),
        ...validatePasswordComplexity(values, (fieldName = 'password')),
        ...validateNotEmpty(values, ['first-name', 'last-name', 'phone']),
      };
      const hasErrors = !$.isEmptyObject(errors);
      $('#personal-register-button').attr('disabled', hasErrors);

      return errors;
    },
    passwordHintField: 'password',
    skipInputs: [
      'submit',
      'csrfmiddlewaretoken',
      'button',
      'form_type',
      'country_select_filter',
    ],
  });

  initializeForm(businessSignUpFormSelector, {
    preventDefault: false,
    validate: (values) => {
      const errors = {
        ...validateEmail(values),
        ...validatePassword(values),
        ...validatePasswordComplexity(values, (fieldName = 'password')),
        ...validateNotEmpty(values, [
          'first-name',
          'last-name',
          'phone',
          'company-name',
        ]),
      };
      const hasErrors = !$.isEmptyObject(errors);
      $('#business-register-button').attr('disabled', hasErrors);

      return errors;
    },
    passwordHintField: 'password',
    skipInputs: [
      'submit',
      'csrfmiddlewaretoken',
      'button',
      'form_type',
      'country_select_filter',
    ],
  });
});
